import React from "react";
import PropTypes from "prop-types";

import ModalVideoPortal from "./ModalVideoPortal";
import YoutubeVideo from "./YoutubeVideo";

export const ModalVideo = ({
  node,
  id,
  isOpened,
  closeText,
  close,
  children,
  missingConsentContent = (
    <div style={{ border: "1px solid red", padding: 24 }}>
      Please supply missing consent content
    </div>
  ),
  thirdPartyConsent,
  ...otherProps
}) => (
  <ModalVideoPortal
    id={id}
    node={node}
    isOpened={isOpened}
    closeText={closeText}
    close={close}
    loadYtVideo={thirdPartyConsent}
    {...otherProps}
  >
    {children}
    {!thirdPartyConsent && missingConsentContent}
  </ModalVideoPortal>
);

ModalVideo.YoutubeVideo = YoutubeVideo;

ModalVideo.propTypes = {
  id: PropTypes.string.isRequired,
  node:
    typeof document !== "undefined"
      ? PropTypes.instanceOf(Element)
      : PropTypes.number,
  isOpened: PropTypes.bool.isRequired,
  closeText: PropTypes.string,
  close: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  thirdPartyConsent: PropTypes.bool,
  missingConsentContent: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

ModalVideo.defaultProps = {
  node: typeof document === "undefined" ? null : document.body,
  closeText: "Schließen",
  close: null,
  children: null,
  thirdPartyConsent: false,
};

ModalVideo.displayName = "ModalVideo";

export default ModalVideo;
